@if (!multipleSelectionAllowed) {
  <div>
    <mat-form-field
      class="picker-form-field"
      [class.disabled]="disabled()"
      [class.mat-form-field-invalid]="shouldShowError()"
      appearance="outline"
      subscriptSizing="dynamic"
    >
      @if (!mappedItems?.length) {
        <mat-label>{{ label ? (label | translate) : '' }}{{ required() ? '*' : '' }}</mat-label>
      }
      <input [value]="mappedItems?.length ? mappedItems[0].scdName : ''" matInput disabled />
      @if (!mappedItems?.length) {
        <button
          class="btn icon-btn btn-primary"
          [disabled]="disabled()"
          [attr.aria-label]="'Select person'"
          (click)="openPeopleSelectionDialog(multipleSelectionAllowed)"
          type="button"
          mat-icon-button
          matSuffix
        >
          <i class="person_add_icon material-icons">person_add</i>
        </button>
      }
      @if (mappedItems?.length > 0) {
        <button
          class="btn icon-btn btn-primary"
          [disabled]="disabled()"
          [attr.aria-label]="'Select person'"
          (click)="removeSelectedPerson(mappedItems[0])"
          type="button"
          mat-icon-button
          matSuffix
        >
          <span class="icon-Trash"></span>
        </button>
      }
    </mat-form-field>
  </div>
} @else {
  <div class="multiple-people-picker-container">
    @if (!hideSelectedItems() && mappedItems?.length) {
      <ul class="people-chiplist">
        @for (item of mappedItems; track item) {
          <li class="people-chiplist__item" (click)="removeSelectedPerson(item)">
            <span>{{ item.scdName }}</span>
            @if (!disabled()) {
              <span>
                <i class="material-icons">person_remove</i>
              </span>
            }
          </li>
        }
      </ul>
    }
    <div class="multiple-people-picker-container__add">
      <button
        class="btn btn-primary btn-withIcon large"
        [disabled]="disabled()"
        (click)="openPeopleSelectionDialog(multipleSelectionAllowed)"
        type="button"
      >
        @if (multipleSelectButtonText()) {
          <span>{{ 'default.selectEmployees' | translate }}</span>
        }
        <i class="person_add_icon material-icons">person_add</i>
      </button>
    </div>
  </div>
}
